import { SearchInput } from "web-design-system";

interface Props {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
}

export default function SearchBar(props: Props) {
  const { onChange } = props;

  return (
    <div className="flex sticky top-0 bg-background z-10 p-2">
      <SearchInput
        onChange={onChange}
        placeholder="Search by name"
        className="w-full"
      />
    </div>
  );
}
